import { capitalizeAndLowercaseRest } from './supportFuncs';

export function initFormVal() {

  // console.log("Form Val initiated");

  const closeButtons = document.querySelectorAll(
    '#close-error-popup, #close-same-name-popup, #close-signature-popup, ' +
    '#close-emerg-name-popup, #close-emerg-phone-popup, #close-parent-match-popup, ' +
    '#close-med-popup, #close-allergy-popup'
  );

  closeButtons.forEach(button => {
    button.addEventListener('click', (event) => {
      const popupWindow = event.target.closest(
        '#form-error-popup, #same-name-popup, #signature-popup, ' +
        '#emerg-name-match-popup, #emerg-phone-match-popup, #parent-name-match-popup, ' +
        '#explain-med-popup, #explain-allergy-popup'
      );
      
      if (popupWindow) {
        console.log(`[Form UI] Dismissing popup frame container: ${popupWindow.id}`);
        popupWindow.style.display = 'none';
      }
    });
  });
}

/**
 * PUBLIC VALIDATION EXPORT: Runs all advanced security business rules for form verification
 * @returns {boolean} True if all rules clear successfully, false if a conflict is caught
 */
export function validateCustomFormRules(params) {
  const {
    studentType, attendanceChoice,
    parentFName, parentLName, parentPhone,
    secondParentFName, secondParentLName,
    emergFName, emergLName, emergPhone,
    medIssues, explainMed,
    allergies, explainAllergy
  } = params;

  // Clean and normalize text strings to eliminate formatting/casing noise
  const ptFNameVal = capitalizeAndLowercaseRest(parentFName || '').trim();
  const ptLNameVal = capitalizeAndLowercaseRest(parentLName || '').trim();
  const emFNameVal = capitalizeAndLowercaseRest(emergFName || '').trim();
  const emLNameVal = capitalizeAndLowercaseRest(emergLName || '').trim();
  const p2FNameVal = capitalizeAndLowercaseRest(secondParentFName || '').trim();
  const p2LNameVal = capitalizeAndLowercaseRest(secondParentLName || '').trim();
  
  const ptPhoneVal = (parentPhone || '').trim();
  const emPhoneVal = (emergPhone || '').trim();
  
  const explainMedVal = (explainMed || '').trim();
  const explainAllergyVal = (explainAllergy || '').trim();

  const medIssuesNormalized = (medIssues || '').toLowerCase().trim();
  const allergiesNormalized = (allergies || '').toLowerCase().trim();

  // =========================================================================
  // 🔍 DEEP INTERIOR RULE INSPECTOR LOGS
  // =========================================================================
  console.log('--- ⚖️ Inside formVal.js Rule Engine ---');
  console.log('medIssuesNormalized vs explanation length: ', `"${medIssuesNormalized}"`, explainMedVal.length);
  console.log('allergiesNormalized vs explanation length: ', `"${allergiesNormalized}"`, explainAllergyVal.length);

  // 🔍 CHECK 1: Secondary Attending Parent cannot match the Primary Parent/Guardian
  const isReturningOrStaff = studentType === '2' || studentType === '3';
  const hasSecondParent = ['Different Parent', 'Two Parents'].includes(attendanceChoice);

  if (isReturningOrStaff && hasSecondParent) {
    if (`${ptFNameVal} ${ptLNameVal}` === `${p2FNameVal} ${p2LNameVal}` && ptFNameVal !== '') {
      console.warn("❌ Failed Check 1: Primary Parent matches Attending Parent.");
      const parentMatchPopup = document.getElementById('parent-name-match-popup');
      if (parentMatchPopup) parentMatchPopup.style.display = "block";
      return false;
    }
  }

  // 🔍 CHECK 2: Emergency Contact cannot match the Primary Parent/Guardian
  if (`${ptFNameVal} ${ptLNameVal}` === `${emFNameVal} ${emLNameVal}` && ptFNameVal !== '') {
    console.warn("❌ Failed Check 2: Parent Name matches Emergency Contact Name.");
    const emergNamePopup = document.getElementById('emerg-name-match-popup');
    if (emergNamePopup) emergNamePopup.style.display = "block";
    return false;
  }

  // 🔍 CHECK 3: Emergency Phone Line cannot match the Primary Parent's line
  if (ptPhoneVal === emPhoneVal && ptPhoneVal !== '') {
    console.warn("❌ Failed Check 3: Parent Phone matches Emergency Phone.");
    const emergPhonePopup = document.getElementById('emerg-phone-match-popup');
    if (emergPhonePopup) emergPhonePopup.style.display = "block";
    return false;
  }

  // 🔍 CHECK 4: Enforce Medical History Explanation if marked "Yes", "yes", or "1"
  if ((medIssuesNormalized === 'yes' || medIssuesNormalized === '1') && explainMedVal === '') {
    console.warn("❌ Failed Check 4: Medical check marked Yes but explanation textbox is completely empty.");
    const explainMedPopup = document.getElementById('explain-med-popup');
    if (explainMedPopup) explainMedPopup.style.display = "block";
    return false;
  }

  // 🔍 CHECK 5: Enforce Food Allergies Explanation if marked "Yes", "yes", or "1"
  if ((allergiesNormalized === 'yes' || allergiesNormalized === '1') && explainAllergyVal === '') {
    console.warn("❌ Failed Check 5: Allergy check marked Yes but explanation textbox is completely empty.");
    const explainAllergyPopup = document.getElementById('explain-allergy-popup');
    if (explainAllergyPopup) explainAllergyPopup.style.display = "block";
    return false;
  }

  console.log('✅ Success: All Custom Business Rules Passed Inside formVal.js!');
  return true; 
}
